<div class="header">
  <ng-ui-kit-header
    #headerRef
    [buttons]="true"
    (onClickTitle)="onLogoClicked()">
    <ng-container buttons *ngIf="logged$ | async; else notLogged">
      <ng-container
        *ngIf="
          userInfoLoaded && (userCertificate$ | async) as certificate;
          else headerUserSkeleton
        ">
        <ng-ui-kit-user
          [icon]="true"
          [title]="certificate.certificateInfo?.subjectDN?.CN"
          [subtitle]="
            (userSession$ | async)?.userInfo
              ? (userSession$ | async)?.userInfo.identity
              : ''
          "
          [items]="userItems$ | async"
          [status]="certificate.active ? 'online' : 'offline'"
          [ariaLabel]="'HEADER.USER_MENU' | translate: { name: certificate.certificateInfo?.subjectDN?.CN || '' }"
          (onChange)="onUserClicked($event)">
        </ng-ui-kit-user>
      </ng-container>
      <app-livechat></app-livechat>
      <!-- <ng-ui-kit-separator [vertical]="true"> </ng-ui-kit-separator> -->

      <!-- <app-contact-support> </app-contact-support> -->

      <!-- TIP: Language moved into user component -->
      <!-- <ng-ui-kit-separator [vertical]="true"> </ng-ui-kit-separator>

    <ng-ui-kit-language
      type="button"
      [languages]="languages$ | async"
      (onChange)="onLanguageChanged($event)">
    </ng-ui-kit-language> -->
    </ng-container>

    <ng-container buttons>
      <ng-template #notLogged>
        <ng-ui-kit-button
          class="pc"
          (onClick)="openUrl('support')"
          iconBefore="contact_support"
          [header]="true"
          [label]="'HEADER.ASSISTENZA' | translate">
        </ng-ui-kit-button>
        <ng-ui-kit-button
          class="mobile"
          (onClick)="openUrl('support')"
          icon="contact_support"
          [header]="true">
        </ng-ui-kit-button>

        <!--
    <ng-ui-kit-button
      (onClick)="openUrl('docs')"
      [header]="true"
      [label]="'HEADER.CONTACT_SUPPORT.DOCS' | translate">
    </ng-ui-kit-button>
    -->
      </ng-template>
    </ng-container>
  </ng-ui-kit-header>
</div>
<app-loading></app-loading>

<ng-template #headerUserSkeleton>
  <div class="header-user-skeleton" aria-hidden="true"></div>
</ng-template>
